import { Alert } from "@components/ui/Alert"
import { Button } from "@components/ui/Button"
import { Spinner } from "@components/ui/Spinner"
import { LoginScreen } from "@features/accounts/panels/LoginScreen"
import { useAuth } from "@features/accounts/useAuth"
import { formatShortDate } from "@utils/date-format"
import { useRPCQuery } from "eddev/hooks"
import { Link } from "eddev/routing"

export function AccountPanel() {
  const auth = useAuth()

  if (!!auth.user) {
    return <AccountScreen />
  } else {
    return (
      <div className="p-4 w-full">
        <LoginScreen loginType="login" />
      </div>
    )
  }
}

function AccountScreen() {
  const auth = useAuth()
  const account = useRPCQuery("api.memberships.getAccount", {
    jwt: auth.session?.access_token ?? "",
  })

  if (account.isPending) {
    return (
      <div>
        <Spinner />
      </div>
    )
  } else if (account.isError) {
    return (
      <div>
        <Alert error>{account.error.message}</Alert>
      </div>
    )
  }

  const self = account.data!

  return (
    <div className="flex flex-col gap-4 items-stretch text-left w-full p-4">
      <div className="stack-y-1">
        <div className="type-label-xs">Welcome back</div>
        <div className="type-title-s">
          {self.details.firstName} {self.details.lastName}
        </div>
        {self.membership && (
          <>
            <div className="flex gap-2 justify-between">
              <div className="stack-y-1 w-full">
                {!!self.membership.levelLabel && (
                  <div className="type-label-s">
                    {self.membership.levelLabel} {self.membership.typeLabel ? ` (${self.membership.typeLabel})` : ""}
                  </div>
                )}
                <div className="flex items-center justify-between w-full">
                  {self.membership.renewalDate && (
                    <div className="type-label-s-light">
                      {self.membership.status === "active" ? "Until" : "Expired"}{" "}
                      {formatShortDate(self.membership.renewalDate)}
                    </div>
                  )}
                  {self.membership.canRenew && (
                    <Link href="/membership" className="type-body-xs underline decoration">
                      Renew
                    </Link>
                  )}
                </div>
              </div>
            </div>
          </>
        )}
      </div>
      <div className="stack-y-1">
        {!self.membership?.typeLabel && (
          <Link href="/membership">
            <Button variant="secondary" className="w-full">
              Become a Member
            </Button>
          </Link>
        )}
        {account.data.codes.length > 0 && (
          <Button variant="secondary" onClick={() => auth.openModal("my-codes", {})}>
            My Member Codes
          </Button>
        )}
        <Button variant="secondary" onClick={() => auth.openModal("my-information", {})}>
          My Information
        </Button>
        <Button variant="secondary" onClick={() => auth.openModal("choose-new-password", {})}>
          Change Password
        </Button>
        <Button onClick={() => auth.api.auth.signOut()}>Sign Out</Button>
      </div>
      {/* <pre>{JSON.stringify(account.data)}</pre> */}
    </div>
  )
}
